import React from 'react'
import { Form, Field } from 'formik'
import { useTranslation } from 'react-i18next'
import Input from 'common/components/Input'

const Registration = () => {
  const { t } = useTranslation()
  return (
    <div className="launcher-inner full">
      <Form id="signup-form" className="form">
        <Field
          name="firstName"
          label={t('First name')}
          component={Input}
        />

        <Field
          name="lastName"
          label={t('Last name')}
          component={Input}
        />

        <Field
          name="email"
          label={t('Email')}
          component={Input}
        />

        <Field
          name="password"
          label={t('Password')}
          component={Input}
          type="password"
        />

        <Field
          name="passwordConfirm"
          label={t('Password confirm')}
          component={Input}
          type="password"
        />

        <Field
          name="cellphone"
          label={t('Mobile')}
          component={Input}
        />

        <Field
          name="companyName"
          label={t('Company name')}
          component={Input}
        />

        <Field
          name="country"
          label={t('Country')}
          component={Input}
        />

        <Field
          name="city"
          label={t('City')}
          component={Input}
        />

      </Form>
    </div>
  )
}

export default Registration
